
import http from '@/http/index.js'

export default {
  data() {
    return {
      apiList: null
    }
  },
  methods: {
    async getApiList() {
      const res = await http.key.queryApi({ key: this.queryForm.key })
      this.apiList = res
      if (this.queryForm && this.queryForm.api) {
        this.queryForm.api = null
      }
    }
  }

}
